import React, { useEffect, useRef, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  RSelect,
  Row,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import { CURRENCY_CODE, MORTGAGE_STATUS } from "../../utils/Utils";

const MORTGAGE_STATUS_OPTIONS = Object.keys(MORTGAGE_STATUS).map((c) => ({
  label: MORTGAGE_STATUS[c],
  value: c,
}));

const MORTGAGE_CURRENCY_OPTIONS = Object.keys(CURRENCY_CODE).map((c) => ({
  label: CURRENCY_CODE[c],
  value: c,
}));

const DEFAULT_LOAN_CONTRACT = {
  id: null,
  bankName: "",
  contractId: "",
  mortgageSource: "",
  disbursementDate: "",
  monthTerm: "",
  maturityDate: "",
  interestRate: "",
  amountUSD: 0,
  exchangeRate: 0,
  amount: 0,
  status: "INIT",
  representative: "",
  currency: "VND",
};

const MortgageContractManager = () => {
  const clearPagi = useRef();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditedId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [deleteId, setDeleteId] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });

  const [filter, setFilter] = useState({
    status: searchParams.get("status") || "INIT",
    representative: searchParams.get("representative") || undefined,
    bankName: searchParams.get("bankName") || undefined,
  });
  const colTable = [
    {
      Header: "Mã hs vay",
      accessor: "contractId",
    },
    {
      Header: "Ngân hàng",
      accessor: "bankName",
    },
    {
      Header: "Nguồn thế chấp",
      accessor: "mortgageSource",
    },
    {
      Header: "Ngày giải ngân",
      accessor: (item) =>
        moment(item.disbursementDate).format("DD/MM/YYYY") || "",
    },
    {
      Header: "Thời hạn(tháng)",
      accessor: "monthTerm",
    },
    {
      Header: "Ngày đáo hạn",
      accessor: (item) =>
        moment(item.maturityDate).format("DD/MM/YYYY") || "",
    },
    {
      Header: "Lãi suất",
      accessor: "interestRate",
    },
    {
      Header: "USD",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.amountUSD}
          displayType={"text"}
          decimalScale={2}
          thousandSeparator={","}
          thousandsGroupStyle="thousand"
        />
      ),
    },
    {
      Header: "Tỷ giá",
      accessor: "exchangeRate",
    },
    {
      Header: "VNĐ",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.amount}
          displayType={"text"}
          decimalScale={2}
          thousandSeparator={","}
          thousandsGroupStyle="thousand"
        />
      ),
    },
    {
      Header: "Trạng Thái",
      accessor: (item) => (item.status === "INIT" ? "KHỞI TẠO" : "KẾT THÚC"),
    },
    {
      Header: "Công Ty Đại Diện",
      accessor: (item) => item.representative,
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.contractId);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.contractId);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      ...DEFAULT_LOAN_CONTRACT
    },
  });

  const currency = watch("currency");
  const amountUSD = watch("amountUSD");
  const exchangeRate = watch("exchangeRate");

  const disbursementDate = watch("disbursementDate");
  const monthTerm = watch("monthTerm");
  useEffect(() => {
    if (disbursementDate && monthTerm) {
      setValue('maturityDate', moment(disbursementDate).add(monthTerm, 'months').format('YYYY-MM-DD'));
    }
  }, [disbursementDate, monthTerm])
  useEffect(() => {
    if (currency === "VND") {
      setValue("amountUSD", null);
      setValue("exchangeRate", null);
    }
  }, [currency, setValue]);

  useEffect(() => {
    if (currency === "USD") {
      setValue("amount", Math.round(amountUSD * exchangeRate));
    }
  }, [currency, amountUSD, exchangeRate, setValue]);

  useEffect(() => {
    const newParams = new URLSearchParams({
      status: filter.status,
      ...(filter.representative ? { representative: filter.representative } : {}),
      ...(filter.bankName ? { bankName: filter.bankName } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        status: filter.status,
        ...(filter.representative ? { representative: filter.representative } : {}),
        ...(filter.bankName ? { bankName: filter.bankName } : {}),
      };

      GET(`/transaction-history/mortgage-contract`, params, true)
        .then(({ data }) => {
          setData(data);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 300)

  }, [filter, timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset({
      ...DEFAULT_LOAN_CONTRACT
    })
    setEditedId();
    setDeleteId();
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/transaction-history/mortgage-contract/detail`, {
      contractId: id
    }, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const formData = getValues();
    formData.exchangeRate = formData.exchangeRate || null;
    formData.amountUSD = formData.amountUSD || null;
    const request = editId
      ? PUT(
        `/transaction-history/mortgage-contract/update`,
        formData,
        {
          contractId: editId
        },
        true
      )
      : POST("/transaction-history/mortgage-contract", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteMortgageContract = (contractId) => {
    if (!contractId) {
      return;
    }
    DELETE(`/transaction-history/mortgage-contract/remove`, {
      contractId
    }, true)
      .then(() => {
        toast.success("Xóa thành công");
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý khoản vay"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Khoản vay</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <Input
                          placeholder="Người đại diện"
                          value={filter.representative}
                          onChange={e => setFilter({
                            ...filter,
                            representative: e.target.value
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <Input
                          placeholder="Ngân hàng"
                          value={filter.bankName}
                          onChange={e => setFilter({
                            ...filter,
                            bankName: e.target.value
                          })}
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          placeholder="Chọn trạng thái"
                          classNamePrefix="form-control"
                          options={MORTGAGE_STATUS_OPTIONS}
                          value={MORTGAGE_STATUS_OPTIONS.find(
                            (c) => c.value === filter.status
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              status: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm khoản vay</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm khoản vay</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="bankName">
                          Ngân hàng <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="bankName"
                            placeholder="Vui lòng nhập tên ngân hàng"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="bankName"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="contractId">
                          Mã hồ sơ vay <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="contractId"
                            placeholder="Vui lòng nhập mã hồ sơ vay"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="contractId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="mortgageSource">
                          Nguồn thế chấp <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="mortgageSource"
                            placeholder="Vui lòng nhập nguồn thế chấp"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="mortgageSource"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label
                          className="form-label"
                          htmlFor="disbursementDate"
                        >
                          Ngày giải ngân <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="date"
                            className="form-control"
                            name="disbursementDate"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="disbursementDate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="monthTerm">
                          Thời hạn (tháng)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="monthTerm"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                placeholder="6"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="monthTerm"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="maturityDate">
                          Ngày đáo hạn <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="date"
                            className="form-control"
                            name="maturityDate"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="maturityDate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="interestRate">
                          Lãi suất (%)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="interestRate"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                placeholder="10"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="interestRate"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Tiền tệ <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="currency"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={MORTGAGE_CURRENCY_OPTIONS}
                                value={MORTGAGE_CURRENCY_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="currency"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    {currency === "USD" ? (
                      <>
                        {" "}
                        <Col size="12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="amountUSD">
                              USD <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="amountUSD"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={4}
                                    onValueChange={(val) => {
                                      onChange(val.floatValue);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="amountUSD"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="12">
                          <div className="form-group">
                            <label
                              className="form-label"
                              htmlFor="exchangeRate"
                            >
                              Tỷ giá <span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="exchangeRate"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    inputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    onValueChange={(val) => {
                                      onChange(val.floatValue);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="exchangeRate"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="amount">
                          VNĐ
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="amount"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                disabled={currency === "USD"}
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) => {
                                  onChange(val.floatValue);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="amount"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Trạng thái <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="status"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={MORTGAGE_STATUS_OPTIONS}
                                value={MORTGAGE_STATUS_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="status"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="representative">
                          Công ty đại diện{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="representative"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <Input value={value} onChange={(e) => onChange(e.target.value)} />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="representative"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>Xác nhận</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá khoản vay này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteMortgageContract(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default MortgageContractManager;
